import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonComponents } from 'src/app/Sharedservice/CommonComponents';
import { MatTabChangeEvent, MatDialog } from '@angular/material';
//import { VisitDetailsComponent } from 'src/app/ChildControls/visit-details/visit-details.component';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { IEncounterData } from 'src/app/models/IEncounterData';
import { Defaults } from 'src/app/Utilities/defaults';
import { Injectable } from '@angular/core';
import { CQMSConfigurationService } from 'src/app/Services/CQMSConfiguration/cqmsconfiguration.service';
import { CQMSVisitNoteFlag } from 'src/app/models/CQMSVisitNoteFlag';
import { PatientBannerService } from 'src/app/patient-banner/patient-banner.service';
import { IReportParameters } from 'src/app/models/IReportParameters';
import { ShowSSRSReportComponent } from 'src/app/ChildControls/show-ssrsreport/show-ssrsreport.component';
import { ConfirmDialogModel, DeleteDocumentComponent } from '../Document/delete-document/delete-document.component';
import { ProceduresService } from 'src/app/Services/NewVisitNote/procedures.service';
@Injectable()
@Component({
  selector: 'app-visit-note-header',
  templateUrl: './visit-note-header.component.html',
  styleUrls: ['./visit-note-header.component.css']
})
export class VisitNoteHeaderComponent implements OnInit, OnChanges {
  isSidebar: boolean = false;
  isSidebars: boolean = false;
  isSilderbarAlert: boolean = false;
  isSilderbarDocuments: boolean = false;
  private _openedAlert: boolean = false;
  private _opened: boolean = false;
  private _openeds: boolean = false;
  private _openedD: boolean = false;

  @Input() encactivetab = 1;
  @Input() LastupdatedOn = '';
  @Output() tabClicked = new EventEmitter<string>();
  @Output() valueChangeForVisitNoteInfo = new EventEmitter();

  refillVisibility: boolean;
  visitNoteStatus: any;
  public encounterId: string;
  public isSignOff: boolean = false;
  public signoffEnc: IEncounterData;
  public appointmentId: string;
  constructor(//private app: AppComponent,
    private route: ActivatedRoute, private router: Router, public dialog: MatDialog
    , private sharedservice: SharedService
    , private cqmsConfigurationService: CQMSConfigurationService,
    private bannerService: PatientBannerService
    , private proService: ProceduresService) {
    // app.isLoggedIn$ = true;
    this.refillVisibility = (sessionStorage.getItem("pumPRefillVisibility") == "True" ? true : false);
    sessionStorage.setItem("visitNoteAlertsheaderVisibility", "true");
    sessionStorage.setItem("AlertsheaderIconVisibility", "true");
    this.getSystem();
    this.encounterId = CommonComponents.encounterId;
    this.getVisitIsSignedoff();

    // if (this.procSessionValue == (null || undefined)) {
    //   this.loadAllFormProceduresdata();
    //   this.loadProceduresTypesdata();
    //   this.loadProceduresSidesdata();
    //   this.loadProceduresLevelsdata();
    //   this.loadProceduresCptCodesdata();
    //   this.loadProceduresOthersdata();
    // }
    //this.getFutureAppointments();

  }

  isUpdate = '';
  ngOnChanges(changes: SimpleChanges): void {
    if (this.LastupdatedOn != '') { }
    //   this.isUpdate = this.LastupdatedOn
  }
  ngOnInit() {
    this.visitNoteStatus = CommonComponents.visitNoteStatus;
    //  this.router.navigateByUrl('/Visitnote/Vitals');
    // this.cqmsAlert();
    this.cqmsConfigurationService.stringSubject.subscribe(
      (e: any) => {
        // alert(e);
        this._visitinfotoggleSidebars(e);
      }
    );
  }
  clickOutside() {
    // alert(0)
    // if (
    // this._opened)
    // this._opened = !this._opened
    // this._toggleSidebars(null)
    this.isSidebars = false;
    this.isSidebar = false;
    //this.isSilderbarAlert = false;
  }
  onLinkClick(event: MatTabChangeEvent) {

    event.tab.isActive = true;
    if (event.tab.textLabel == 'Forms') {
      //this.router.navigateByUrl('/ConsentForms/' + Defaults.DocLibraryVisitNote);
      this.tabClicked.emit('ConsentForms/' + Defaults.DocLibraryVisitNote);
      return;
    }
    if (event.tab.textLabel == 'Visit Notes') {

      // this.router.navigateByUrl('/ProgressNotes');
      this.tabClicked.emit('ProgressNotes');
      return;
    }

    this.tabClicked.emit(event.tab.textLabel);
    // this.router.navigateByUrl('/Visitnote/'+event.tab.textLabel); 
    //  this.router.navigateByUrl('/'+event.tab.textLabel.replace(" ","")); 
    //  this.tabClicked.emit();
  }

  getSystem() {
    if (sessionStorage.getItem("encounterid") != null || sessionStorage.getItem("encounterid") != undefined) {
      CommonComponents.encounterId = sessionStorage.getItem("encounterid");
    }
    if (sessionStorage.getItem("patientId") != null || sessionStorage.getItem("patientId") != undefined) {
      CommonComponents.patientId = parseInt(sessionStorage.getItem("patientId"));
    }
    if (sessionStorage.getItem("appId") != null || sessionStorage.getItem("appId") != undefined) {
      this.appointmentId = sessionStorage.getItem("appId");
    }
  }

  // getVisitDetails():void
  // {
  //   const dialogRef = this.dialog.open(VisitDetailsComponent, {
  //     width: '800px',
  //     height: '100%',
  //     data: {signOff : this.isSignOff}
  //   });

  //   dialogRef.afterClosed().subscribe(result => {
  //   });
  // }

  getVisitIsSignedoff() {
    if (this.encounterId != undefined) {
      this.sharedservice.getIsSignedoff(this.encounterId, Defaults.encNoteType_VisitNoteId).subscribe(data => {
        this.signoffEnc = data;
        if (data != undefined) {
          this.isSignOff = this.signoffEnc.isSignOff;
        }
      })
    }
  }
  // closetheBox(x){
  //   x.preventDefault()
  //   alert();
  //   this._opened = !this._opened;
  // }

  showCQMS: boolean = false;
  _toggleSidebar(event) {
    //  alert('cqms fired')

    this.isSidebars = true;
    this.isSidebar = false;
    this.isUpdate = Date.now().toString();
    this._opened = true;
    this.showCQMS = !this.showCQMS;
    this.showCQMS = true;
    this.isSilderbarAlert = false;
    this._openedD = false;
    this.isSilderbarDocuments = false;
    this._openedAlert = false;
  }

  public _toggleSidebars(event) {

    this.isSidebars = false;
    this.isSidebar = true;
    this._openeds = true;
    this.isSilderbarAlert = false;
    this._openedD = false;
    this.isSilderbarDocuments = false;
    this._openedAlert = false;
  }
  public _visitinfotoggleSidebars(event) {
    this.isSidebars = false;
    this.isSidebar = false;
    this.isUpdate = Date.now().toString();
    this._opened = false;
    this._openeds = false;
    this.isSilderbarAlert = false;
    this._openedD = false;
    this._openedAlert = false;
    this.isSilderbarDocuments = false;
  }
  public _AlertSidebar(event) {
    this.isSidebars = false;
    this.isSidebar = false;
    this.isSilderbarAlert = true;
    this._openedAlert = !this._openedAlert;
    this._openeds = false;
    this._openedD = false;
    this.isSilderbarDocuments = false;
    // this._opened = true;
    this._opened = true;
    sessionStorage.setItem("visitNoteAlertsheaderVisibility", "false");
    // sessionStorage.setItem("AlertsheaderIconVisibility", "true");
    sessionStorage.setItem("AlertsheaderIconVisibility", "true");
  }
  Isdocument: boolean = false;
  public DocumentsSidebar(event) {
    sessionStorage.setItem("fromscreen", "visitdocument");
    this.isSidebars = false;
    this.isSidebar = false;
    this._openedD = !this._openedD;
    this._openeds = false;
    this._openedAlert = false;
    this.isSilderbarAlert = false;
    this.isSilderbarDocuments = true;
    sessionStorage.setItem("hideDocumentsHeader", "true");
    this.Isdocument = true;
  }



  closeAlerts() {
    this._openedAlert = false;
  }
  closeDocuments() {
    this._openedD = false;
    this.Isdocument = false;
  }
  flagsList: CQMSVisitNoteFlag[] = [];
  isAlert: boolean = false;
  isRedShow: boolean = false;
  cqmsAlert() {
    this.cqmsConfigurationService.GetCQMSVisitFlags(CommonComponents.patientId, CommonComponents.encounterId, 13).subscribe(data => {
      this.flagsList = data;
      if (this.flagsList[0].patAge >= 18) {
        if (this.flagsList[0].bmiQualifyDesc != "" && this.flagsList[0].bmiQualifyDesc != null) {
          this.isAlert = true;
        }
        else {
          this.isAlert = false;
        }
        if (this.flagsList[0].advanceDesc != "" && this.flagsList[0].advanceDesc != null) {
          this.isAlert = true;
        }
        else {
          this.isAlert = false;
        }
        if (this.flagsList[0].pneumococcalDesc != "" && this.flagsList[0].pneumococcalDesc != null) {
          this.isAlert = true;
        }
        else {
          this.isAlert = false;
        }
        if (this.flagsList[0].opioidDesc != "" && this.flagsList[0].opioidDesc != null) {
          this.isAlert = true;
        }
        else {
          this.isAlert = false;
        }
        if (this.flagsList[0].docSignedDesc != "" && this.flagsList[0].docSignedDesc != null) {
          this.isAlert = true;
        }
        else {
          this.isAlert = false;
        }
        if (this.flagsList[0].evaluationDesc != "" && this.flagsList[0].evaluationDesc != null) {
          this.isAlert = true;
        }
        else {
          this.isAlert = false;
        }
        if (this.flagsList[0].docCurrentMedDesc != "" && this.flagsList[0].docCurrentMedDesc != null) {
          this.isAlert = true;
        }
        else {
          this.isAlert = false;
        }
        // if (this.flagsList[0].highRiskMedDesc != "" && this.flagsList[0].highRiskMedDesc != null) {
        //   this.isAlert = true;
        // }
        // else {
        //   this.isAlert = false;
        // }
        // if (this.flagsList[0].C2highRiskMedDesc != "" && this.flagsList[0].C2highRiskMedDesc != null) {
        //   this.isAlert = true;
        // }
        // else {
        //   this.isAlert = false;
        // }
        if (this.flagsList[0].CloseRefDesc != "" && this.flagsList[0].CloseRefDesc != null) {
          this.isAlert = true;
        }
        else {
          this.isAlert = false;
        }

        if (this.isAlert) {
          this.isRedShow = false;
        } else {
          this.isRedShow = true;
        }
      } else {
        this.isRedShow = false;
      }
    });
  }
  onClickCancel() {

    sessionStorage.removeItem("patientId");
    sessionStorage.removeItem("patientName");
    localStorage.removeItem("isBackBtnVisibleInVisitNotes");
    var displayDate = sessionStorage.getItem("displayappDate");
    sessionStorage.setItem("displayDate", displayDate);
    CommonComponents.patientId = 0;
    CommonComponents.patientName = '';
    this.bannerService.toggle(Number("-1"));
    this.router.navigate(["Appointments"]);

  }

  public count: number;
  public patId: number;
  async getFutureAppointments() {
    await this.sharedservice.getFeatureAppointmentsCount(CommonComponents.encounterId, CommonComponents.patientId).subscribe(data => {
      this.count = Number(data);

      if (this.count != 0) {

        this.onClickFeatureAppointments();
      } else {
        // alert('Zero')
        this.futureAppointmentWarning()
      }
    });

  }
  public reportParamters: IReportParameters;
  onClickFeatureAppointments() {
    this.reportParamters = new IReportParameters();
    this.reportParamters.reportUrl = 'NEMR/PatientFutureAppDetails';
    this.reportParamters.parameters = {
      "appId": sessionStorage.getItem("appId"),
      "locationId": Number(sessionStorage.getItem("LocationId")),
      "patId": sessionStorage.getItem("patientId")
    };
    const dialogRef = this.dialog.open(ShowSSRSReportComponent, {
      width: '850px',
      height: '100%',
      data: this.reportParamters
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  result: any;
  futureAppointmentWarning() {
    //  alert("category clicked" + categoryCodeId);  
    const message = "Future Appointment are not available. do you want to create a new Appointment ? ";
    const dialogData = new ConfirmDialogModel('Confirm Action', message);
    const dialogRef = this.dialog.open(DeleteDocumentComponent, {
      maxWidth: '400px',
      height: '150px',
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      this.result = dialogResult;
      this.router.navigate(["NewAppointment"]);
    });

  }


  displayRenderingProviderVisitNoteHeader(event) {

    this._openedAlert = !this._openedAlert;
    this.valueChangeForVisitNoteInfo.emit(event);
  }
  // @SessionStorage() procSessionValue: any;
  // @SessionStorage() sideSessionValue: any;
  // @SessionStorage() levelsSessionValue: any;
  // @SessionStorage() OthersSessionValue: any;
  // @SessionStorage() typesSessionValue: any;
  // @SessionStorage() cptCodesSessionValue: any;

  // loadAllFormProceduresdata() {
  //   this.proService.getAllProcedureData(1).subscribe((data) => {
  //     this.procSessionValue = data;
  //   }
  //     , (err: any) => {
  //       console.log(err);
  //     });
  // }

  // loadProceduresTypesdata() {
  //   this.proService.getProcedureTypes().subscribe((data) => {
  //     this.typesSessionValue = data;
  //   }
  //     , (err: any) => {
  //       console.log(err);
  //     });
  // }

  // loadProceduresSidesdata() {
  //   this.proService.getProcedureSides().subscribe((data) => {
  //     this.sideSessionValue = data;
  //   }
  //     , (err: any) => {
  //       console.log(err);
  //     });
  // }

  // loadProceduresLevelsdata() {
  //   this.proService.getProcedureLevels().subscribe((data) => {
  //     this.levelsSessionValue = data;
  //   }
  //     , (err: any) => {
  //       console.log(err);
  //     });
  // }

  // loadProceduresCptCodesdata() {
  //   this.proService.getProcedureCptCodes().subscribe((data) => {
  //     this.cptCodesSessionValue = data;
  //   }
  //     , (err: any) => {
  //       console.log(err);
  //     });
  // }

  // loadProceduresOthersdata() {
  //   this.proService.getProcedureOthers().subscribe((data) => {
  //     this.OthersSessionValue = data;
  //   }
  //     , (err: any) => {
  //       console.log(err);
  //     });
  // }
}







